import React from 'react';

/**
 * Toast — centered modal popup notification.
 *
 * Props:
 *   message  {string}
 *   type     {'error'|'success'|'info'}  (default: 'error')
 *   onClose  {() => void}
 */
const Toast = ({ message, type = 'error', onClose }) => {
  if (!message) return null;

  return (
    <div className="toast-backdrop" onClick={onClose} role="presentation">
      <div
        className="toast-modal"
        role="alertdialog"
        aria-modal="true"
        aria-label={type}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="toast-modal__msg">{message}</p>
        <button className="toast-modal__btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Toast;
